<template>
    <div
        id="tourModels"
        ref="virtualTourModelsHolder"
        class="content-widget virtual-tour-models"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapActions, mapGetters } from 'vuex';

    import Vue from 'vue';

    export default {
        name: 'VirtualTourModels',
        props: [
            'data',
            'link',
            'active',
            'standalone'
        ],
        data: () => ({
            isIE: false,
            widget: null
        }),
        computed: {
            ...mapGetters([
                'isOfflineMode',
                'isReviewUse',
                'language',
                'protocol',
                'isAlternativeMode'
            ]),
            apiUrl() {
                return 'https://' + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.isIE = window.navigator.msPointerEnabled;
            this.render();

            EventBus.$on('models_SetActive', (item, subitem) => { 
                this.setActive(item, subitem);
            });
        },
        methods: {
            ...mapActions([
                'setIsLoading'
            ]),
            setActive(item, subitem) {
                let localData = _.cloneDeep(this.data);
                localData.items.filter(el => el.subid === item.subid)[0].loaded = true;
                if (subitem) {
                    if (!subitem.active) {
                        localData.items.filter(el => el.active).forEach(el => el.active = false);
                        localData.items.filter(el => el.subid === item.subid)[0].submenu.filter(el => el.active).forEach(el => el.active = false);
                        localData.items.filter(el => el.subid === item.subid)[0].active = true;
                        localData.items.filter(el => el.subid === item.subid)[0].submenu.filter(el => el.text === subitem.text)[0].active = true;
                        localData.items.filter(el => el.subid === item.subid)[0].link = subitem.link;
                        EventBus.$emit('updateSidebar', localData, false);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: item.id,
                            link: subitem.link,
                            active: true
                        });
                    } else {
                        if (!item.active) {
                            localData.items.filter(el => el.active).forEach(el => el.active = false);
                            localData.items.filter(el => el.subid === item.subid)[0].active = true;
                            EventBus.$emit('updateSidebar', localData, false);
                            EventBus.$emit('updateLoadedWidgets', {
                                id: item.id,
                                link: subitem.link,
                                active: true
                            });
                        }
                    }
                }
                else {
                    if (!item.active && !item.submenu) {
                        localData.items.filter(el => el.active).forEach(el => el.active = false);
                        localData.items.filter(el => el.subid === item.subid)[0].active = true;
                        EventBus.$emit('updateSidebar', localData, false);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: item.id,
                            link: item.link,
                            active: true
                        });
                    }
                }
            },
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/virtual-tour-models' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                if (this.isOfflineMode && !urlLink.includes('&offline'))
                    urlLink += '&offline';
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        payload.type = 'models';
                        if (payload.gui && payload.gui.autorotate && payload.gui.autorotate.active) {
                            payload.gui.autorotate.active = !(this.canBeEditable || this.isExportMediaEnabled);
                            payload.gui.autorotate.visible = !this.canBeEditable;
                        }
                        if (payload.gui)
                            EventBus.$emit('updateSidebar', Object.assign(this.$props.data, { 'gui': payload.gui }), false);
                        
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        payload.showCompass = false;
                        this.getKrpanoConfig(payload.private.krpanoURI, jsonData => {
                            payload.jsonConfig = jsonData;
                            let vm = this;
                            payload = Object.assign(payload, {
                                callbacks: {
                                widgetReadyCallback(widget,data) {
                                    if (vm.$props.data.gui)
                                        data.gui = vm.$props.data.gui;

                                    EventBus.$emit('trackWidget', payload.tracking);
                                    vm.setIsLoading(false);
                                    }
                                }
                            });

                            payload.dependencies = {
                                'vue': Vue
                            };

                            if (this.isReviewUse)
                                this.widget = new Habiteo.PanoWidget(this.$refs.virtualTourModelsHolder, payload, document.getElementById('fullScreen'));
                            else{
                                payload.isInternal = this.isInternal;
                                this.widget = new Habiteo.VirtualTourWidget(this.$refs.virtualTourModelsHolder, payload, document.getElementById('fullScreen'));
                            }

                            if (this.standalone)
                                EventBus.$emit('setSidebarData', payload);
                            else
                                EventBus.$emit('updateSidebar', payload, false);
                            EventBus.$emit('trackWidget', payload.tracking);
                        });
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            updateWidget(link) {
                Http.getData(link).then(payload => {
                    if (payload) {
                        payload = Object.assign(this.data, payload);
                        this.getKrpanoConfig(payload.getMetadataURI, jsonData => {
                            payload.jsonConfig = jsonData;
                            payload.isInternal = this.isInternal;
                            this.widget = new Habiteo.VirtualTourWidget(this.$refs.virtualTourModelsHolder, payload, document.getElementById('fullScreen'));
                            EventBus.$emit('updateSidebar', payload, false);
                            EventBus.$emit('trackWidget', payload.tracking);
                        });
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            triggerResize() {
                if (this.isIE) {
                    let evt = window.document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                } else
                    window.dispatchEvent(new Event('resize'));
            },
            getKrpanoConfig(apiUrl, callback) {
                Http.getData(apiUrl).then(payload => {
                    callback(payload);
                }).catch(error => {
                    // this.errorState = true;
                    console.error('Error :', error);
                    callback(null);
                });
            }
        },
        watch: {
            active(val) {
                if (val)
                    this.render()
            },
            link(val) {
                if (this.active)
                    this.updateWidget(val);
            }
        }
    };
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/main.scss";
    @import "@/assets/scss/components/_sidebar.scss";
</style>



// WEBPACK FOOTER //
// src/views/VirtualTourModelsWidget.vue